import React, { useState, useCallback, useMemo } from 'react';
import { Typography, Box, useMediaQuery, useTheme, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import OurLawInfo from './OurLawInfo';

const PRIMARY = '#c4122f';

interface AddStep1CompanyUnitProps extends StepProps {
  companyUnits: { id: number; name: string }[];
  onCompanyUnitSelect: (u: any) => void;
  currentStepName:String;
      ourLawInfo:any;
    setOurLawInfo:(any)=>void;
}

const AddStep1CompanyUnit = ({
  onNext,
  onBack,
  onCancel,
  currentData,
  isFirstStep,
  companyUnits,
  onCompanyUnitSelect,
   currentStepName,
   ourLawInfo,
    setOurLawInfo
}: AddStep1CompanyUnitProps) => {
  const [selectedUnits, setSelectedUnits] = useState<{ id: number; name: string }[]>(
    currentData.selectedUnits || [],
  );
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);
  const selectOptions = useMemo(() => companyUnits.map(u => ({ value: u.id, label: u.name })), [companyUnits]);

  const handleChange = useCallback((val: TypedFormFieldValue<number> | TypedFormFieldValue<number>[] | undefined) => {
    if (Array.isArray(val)) {
      const units = val.map(v => companyUnits.find(u => u.id === v.value)).filter(Boolean) as { id: number; name: string }[];
      setSelectedUnits(units);
    } else if (val) {
      const unit = companyUnits.find(u => u.id === val.value);
      setSelectedUnits(unit ? [unit] : []);
    } else {
      setSelectedUnits([]);
    }
  }, [companyUnits]);

  const handleNext = () => {
    if (selectedUnits.length > 0) {
      onCompanyUnitSelect(selectedUnits);
      onNext({
        CustomerCompanyUnitId: selectedUnits[0].id,
        _companyUnitName: selectedUnits.map(u => u.name).join(', '),
        selectedUnits
      });
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {/* <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: "100%",
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >

          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <SelectField
              name="company-unit"
              placeholder={formatMessage({ id: 'form.selectCompanyUnits' })}
              options={selectOptions}
              errorTexts={[]}
              isMulti={true}
              initialState={selectedUnits.length > 0 ? selectedUnits.map(u => ({ value: u.id, label: u.name })) : undefined}
              onChange={handleChange}
            />
          </Box>
        </div>
      </div> */}
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: "350px"
          }}
        >
          {/* <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(5),
              lineHeight: 1.4,
              textAlign: 'center',
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({
              id: 'law-portal.evalution.plan.select.type.title',
            })}
          </Typography> */}

          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="flex-start">
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <SelectField
                  name="company-unit"
                  placeholder={formatMessage({ id: 'form.selectCompanyUnits' })}
                  options={selectOptions}
                  errorTexts={[]}
                  isMulti={true}
                  initialState={selectedUnits.length > 0 ? selectedUnits.map(u => ({ value: u.id, label: u.name })) : undefined}
                  onChange={handleChange}
                />
              </Grid>

            </Grid>
          </Box>
        </div>

        <OurLawInfo ourLawStepInfo={ourLawInfo} currentStepName={currentStepName} onUpdate={setOurLawInfo} />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={selectedUnits.length === 0}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default AddStep1CompanyUnit;
